/**
 * French display labels for the API event-type catalog.
 *
 * Source of truth: KantoBizApi/preferences/eventTypes.py (EVENT_TYPES).
 * API payloads only carry the lowercase snake_case key, never the label, so the
 * admin resolves it here. This file is generated from the catalog: do not edit
 * an entry by hand, regenerate it when the catalog changes.
 */
export const EVENT_TYPE_LABELS = {
    // Private & family
    wedding: "Mariage",
    engagement_party: "Fiançailles",
    birthday_party: "Anniversaire",
    anniversary: "Anniversaire de mariage",
    baptism: "Baptême",
    communion: "Communion",
    bar_mitzvah: "Bar-mitsvah",
    circumcision_party: "Fête de circoncision",
    baby_shower: "Baby shower",
    gender_reveal: "Gender reveal",
    bachelor_party: "Enterrement de vie de garçon",
    bachelorette_party: "Enterrement de vie de jeune fille",
    family_reunion: "Réunion de famille",
    graduation_party: "Fête de remise de diplôme",
    retirement_party: "Pot de départ à la retraite",
    housewarming: "Pendaison de crémaillère",
    memorial_service: "Cérémonie commémorative",
    // Corporate
    corporate_event: "Évènement d'entreprise",
    conference: "Conférence",
    seminar: "Séminaire",
    team_building: "Team building",
    product_launch: "Lancement de produit",
    gala_dinner: "Dîner de gala",
    award_ceremony: "Remise de prix",
    office_party: "Fête de bureau",
    christmas_party: "Fête de Noël",
    networking_event: "Soirée networking",
    trade_show: "Salon professionnel",
    store_opening: "Ouverture de magasin",
    inauguration: "Inauguration",
    // Culture & show
    concert: "Concert",
    festival: "Festival",
    showcase: "Show-case",
    fashion_show: "Défilé de mode",
    theater_performance: "Représentation théâtrale",
    art_exhibition: "Exposition d'art",
    film_premiere: "Avant-première",
    album_release: "Sortie d'album",
    open_mic: "Scène ouverte",
    carnival: "Carnaval",
    parade: "Défilé",
    // Party & nightlife
    private_party: "Soirée privée",
    club_night: "Soirée en club",
    pool_party: "Pool party",
    beach_party: "Fête à la plage",
    garden_party: "Garden-party",
    rooftop_party: "Soirée rooftop",
    new_year_party: "Réveillon du Nouvel An",
    halloween_party: "Soirée Halloween",
    themed_party: "Soirée à thème",
    // Traditional & religious
    traditional_party: "Fête traditionnelle",
    cultural_festival: "Festival culturel",
    religious_ceremony: "Cérémonie religieuse",
    famadihana: "Famadihana",
    village_festival: "Fête de village",
    // Sport
    sports_event: "Événement sportif",
    tournament: "Tournoi",
    race: "Course",
    esports_event: "Événement e-sport",
    // Public & charity
    charity_gala: "Gala de charité",
    fundraiser: "Collecte de fonds",
    street_performance: "Spectacle de rue",
    town_festival: "Fête municipale",
    political_event: "Événement politique",
    association_event: "Évènement associatif",
    // Media & education
    tv_show: "Émission TV",
    radio_show: "Émission radio",
    livestream: "Livestream",
    video_shoot: "Tournage vidéo",
    photo_shoot: "Séance photo",
    school_party: "Fête scolaire",
    student_party: "Soirée étudiante",
    prom: "Bal de promo",
};

/**
 * Turns an unknown raw event value into a readable label.
 * Covers custom keys created at booking time ("soutenance_de_these") and the
 * legacy French values still stored on pre-migration reservations ("Mariage").
 * @param {string} value - Raw event value
 * @returns {string} Prettified value: underscores as spaces, capitalized first letter
 */
function prettifyEventValue(value) {
    const spaced = value.replace(/_/g, " ").trim();
    if (!spaced) return "";
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/**
 * Resolves the French label of a reservation event type.
 * Returns the catalog label for a known key, a prettified fallback otherwise,
 * and an empty string for missing values so callers keep their own placeholder.
 * @param {string} value - Event key or legacy French label
 * @returns {string} Display label
 */
export function eventTypeLabel(value) {
    if (!value || typeof value !== "string") return "";
    const known = Object.prototype.hasOwnProperty.call(EVENT_TYPE_LABELS, value);
    return known ? EVENT_TYPE_LABELS[value] : prettifyEventValue(value);
}
